import { useAuth } from "@bw/shared/hooks";
import { useMyRating } from "../hooks/useMyRating";
import { standingLabel } from "./competeDisplay";

/**
 * The player's tier and division as a trailing " · Silver Division 4" fragment
 * for the Me header ("Unrated" before placement). Renders nothing until
 * the server rating is available.
 */
export function MyStandingLabel() {
  const { user } = useAuth();
  const rating = useMyRating(Boolean(user));
  if (!rating.data) return null;
  return <>{` · ${standingLabel(rating.data)}`}</>;
}
